(() => {
  let observer;
  let frame;

  const params = new URLSearchParams(location.search);
  const isSearchPage = location.pathname.replace(/\/$/, '').endsWith('/search');
  if (isSearchPage && (params.get('device_filter') !== '1' || params.has('filters'))) return;

  let activeDeviceLabel;
  try {
    activeDeviceLabel = JSON.parse(localStorage.getItem('cellect.devices') || '{}').activeDeviceLabel;
  } catch (_) {}
  if (!activeDeviceLabel) return;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function applyFilter() {
    const activeLabel = normalize(activeDeviceLabel);
    const options = [...document.querySelectorAll('.rps-filter-block-container.rps-filter-tags .rps-filter-checkbox')]
      .map((option) => ({
        option,
        label: normalize(option.querySelector('.rps-filter-checkbox-label')?.textContent),
      }));
    const option = options.find((item) => item.label === activeLabel)?.option
      || options
        .filter((item) => item.label && activeLabel.endsWith(` ${item.label}`))
        .sort((a, b) => b.label.length - a.label.length)[0]?.option;
    if (!option) return false;

    option.click();
    return true;
  }

  function scheduleApply() {
    if (frame) return;

    frame = requestAnimationFrame(() => {
      frame = undefined;
      if (!applyFilter()) return;
      observer?.disconnect();
      observer = undefined;
    });
  }

  function start() {
    observer = new MutationObserver(scheduleApply);
    observer.observe(document.getElementById('MainContent') || document.body, {
      childList: true,
      subtree: true,
    });
    scheduleApply();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
